import React, { useRef, useState, useEffect, useCallback } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import {
	getListingData,
	getVendorProducts,
	resetSearchData,
	setCurrentEditPage, 
	updateDeletionPending, 
	updateProductStatus, 
	deleteProduct, 
	toggleConfirmDelete,
	setTabStatus,
	toggleEditProductSlider
} from '../../actions/products';
import SliderHeader from 'jd-library/SliderHeader';
import useOnScroll from 'jd-library/useOnScroll';
import AnimateOnHover from 'jd-library/AnimateOnHover';
import { useHistory } from 'react-router-dom';
import style from './search-product.scss';
import noResultStyle from '../../common/NoResultFound/no-result-found.scss';
import ProductList from '../../common/product-list/ProductList';
import CSSTransition from '../../common/transition/Animation';
import VideoListing from '../../pages/listing/VideoListing';
import JdCategoryCover from '../../pages/jd-category-cover/jdCategoryCover';
import ConfirmDelete from '../listing/ConfirmDelete';
import AuthWrapper from '../../common/AuthWrapper';
import Button from '../../common/Button/Button';
import {identifyAuditFlow} from '../../utills';
import NoResultFound from '../../common/NoResultFound/NoResultFound';
import toastMessageActions from "jd-library/toastMessageActions";
import { showHideLoader } from '../../actions';
import { showHideJdCatCover } from '../../actions/jdCategoryCover';
import { getRouteChangeMessage as getToastMessage } from '../../utills.js';

const SearchProduct = React.forwardRef(({ className, ...props }, ref) => {
	let result = props.search.results;
	const dispatch = useDispatch();
	const showCatCoverSlider = useSelector(state=>state.jdCategoryList.showCatCoverSlider)
	const inputRef = React.createRef();
	const searchResultHolder = useRef(null);
	const [backClick, setBackClick] = useState(false);
	const [isSearching, setIsSearching] = useState(false);
	const [searchText, setSearchText] = useState(props.search.searchQuery);
	const [inputFocus, setInputFocus] = useState(true);
	let prevScrollPos = 0;
	const getScrollTop = () => {
		if(props.deviceData.isIphone || props.deviceData.isIphoneApp){
			return 1;
		}
		if(props.deviceData.isMobile){
			return document.scrollingElement.scrollTop;
		}
		let scrollingElement = searchResultHolder.current;
		return scrollingElement ? scrollingElement.scrollTop : 0
	}
	
	useEffect(() => {
		setTimeout(() => {
			  getData(props.search.searchQuery) 
			  dispatch(toggleEditProductSlider({fromEditProductService:false}));
			  props.deviceData.isMobile && window.scrollTo(0,1);
		}, 500); 
	  }, [props?.fromEditProductService])
	    
	const [isScrolled, setScroll] = useState(
		typeof document === 'object' && (getScrollTop() > 110)
	);

	const [scrollVal, setScrollVal] = useState(0)

	let history = useHistory();

	let isAuditUrl = false;
	let isSpecialContract = false;
	const flowCheck = identifyAuditFlow({checkType: true});
	if(flowCheck.fetchNextAudit) {
		isAuditUrl = true;
	}
	if(flowCheck.isSpecialContract){
		isSpecialContract = true;
	}

	const selectTypeQuery = identifyAuditFlow({query: true});
	let viaSuggestedSearch = selectTypeQuery.viaSuggested === 'true';

	const isAuditor = props.session.user.loggedUser && props.session.user.loggedUser.userType == "AUDITOR" && isAuditUrl ? true : false;

	const onValChange = e => {
		let inputVal = e ? e.currentTarget.value : '';
		setSearchText(inputVal);
		getData(inputVal);
		if (!e && inputRef.current) {
			inputRef.current.focus();
			props.updateDeletionPending({deletionPendingList: []});
		}
	};

	const getData = inputVal => {
		if (inputVal) {
			setIsSearching(true);
			if(props.session.source == "webstore") {
				props.getVendorProducts({
					isSearch: true,
					searchText: inputVal
				})
				.then(res => {
					setIsSearching(false);
				})

			} else {
				props
					.getListingData({
						isSearch: true,
						supplierId: props.session.supplierId,
						searchText: inputVal,
						tabKey: props?.tabKey || props?.search?.searchTab,
						isPhoto: props.isPhoto,
						cb: () => {
							setIsSearching(false);
						}
					})
			}
				
		} else {
			props.resetSearchData();
		}
	};

	const goBack = () => {
		// window.history.back();
		if(props.session.source == 'webstore'){
			props.getVendorProducts({}).then(() => {
				history.goBack();
				setTimeout(() => {
					props.resetSearchData();
				}, 300)
			});
		}else{
			history.goBack();
			let filterStr = "";
			let isFilter = false;
			if(props.session.viaOmni && props?.filterProductObj && Object.keys(props.filterProductObj).length) {
				Object.keys(props.filterProductObj).forEach((key) => {
					filterStr += '&' + key + '=' + props.filterProductObj[key][0];
				});
			}
			if(filterStr?.length) {
				isFilter = true;
			}
			props.getListingData({tabKey:props.tabKey,supplierId: props.session.supplierId, isFilter, filterStr}).then(() => {
				setTimeout(() => {
					props.resetSearchData();
				}, 300)
			});
		}
	};

	let leftIconArr = [
		{
			className: 'icon-hdrBackNew',
			onClick: () => {
				if(!backClick){
					setBackClick(true);
					setTimeout(() => {
						goBack();
					}, 300)
				}
			}
		}
	];

	let rightIconArr = [
		{
			className: 'icon-HDRcross',
			onClick: () => {
				if(!backClick){
					setBackClick(true);
					setTimeout(() => {
						goBack();
					}, 300)
				}
			}
		}	
	];

	const closeKeypad = () => {
		// inputRef.current.blur();
		setInputFocus(false);
		document.getElementById('searchProduct').blur();
	};

	const handleScroll = useCallback(() => {
		const scrollTop = getScrollTop();
		setScrollVal(scrollTop)
		if(props.session.source == "webstore") {
			if(prevScrollPos > scrollTop && scrollTop == 0){
				setScroll(false);
			} else {
				setScroll(scrollTop > 0);
			}
		} else {
			if((prevScrollPos >scrollTop) && props.deviceData.isMobile){
				setScroll(false);	
			}else{
				setScroll(scrollTop > 100);
			}
		}
		prevScrollPos = scrollTop;
	}, []);

	//Multiple deletion
	const [productData, setProductData] = useState({});
	const [isMultiSelect, setMultiSelect] = useState(false);
	const confirmDelete = (productData, isMultiSelectFlag) => {
		setMultiSelect(isMultiSelectFlag);
		setProductData(productData);
		props.toggleConfirmDelete({confirmDeleteModal: true});
	}

	const fetchSearchData = () => {
		getData(searchText);
	}

	const redirectToAddProduct = (selectedProductType = '') => {};

	const handleShowJdCatCover = ()=>{
		dispatch(showHideJdCatCover(false));
	}

	const deleteProduct = () => {
		if(productData.cb){
			productData.cb();
		}else{
			props.showHideLoader({
				showLoader: true
			})
			let productToDelete = productData.pidList ? productData.pidList : productData.productId;
			let toastMessage = `${productData.type == 'service' ? 'Service' : 'Product'} Deleted Successfully`;
			if(isMultiSelect){
				productToDelete = props.deletionPendingList.toString();
				toastMessage = props.deletionPendingList.length + ` ${productData.type == 'service' ? 'Services' : 'Item(s)'} Deleted Successfully`;
			}
			props.deleteProduct(productToDelete, fetchSearchData, productData.productId,{isSearch: true,searchText: searchText,cb: () => {
				setIsSearching(false);
				props.showHideLoader({
					showLoader: false
				})
			}});
			dispatch(toastMessageActions.showMessage({
				message: toastMessage,
				showReduxToast: true,
				animationTime :5000
			}))
			setTimeout(() => {
				props.updateDeletionPending({deletionPendingList: []});
			}, 300);
		}
		window.history.back();
	}

	const onDeleteModalClose = () => {
		props.toggleConfirmDelete({confirmDeleteModal: false});
	}
	useEffect(() => {
		let toastmsg = getToastMessage();
		let params = new URLSearchParams(location.search.substring(1));
		let query = params.get("query");
		props.session.source != 'webstore' && inputRef.current.focus();
		props.setCurrentEditPage('search');
		if (searchText) {
			getData(props.search.searchQuery);
		}else if(query) {
			setSearchText(query);
			getData(query);
		}
		if(viaSuggestedSearch){
			dispatch(setTabStatus({ tabKey: 'brand' }))
		}
	}, []);
	useOnScroll({
		callback : (e,a) => {
			handleScroll(e);
		},
		element : props.deviceData.isMobile ? null : searchResultHolder,
	})

	return (
		<>
		{showCatCoverSlider ?
			<JdCategoryCover
				redirectToAddProduct= {redirectToAddProduct}
				onHidden={handleShowJdCatCover}
			/> : null
		}
		<div className={`${style['search-holder']} ${props.deviceData.isMobile ? '' : 'web-page'}`} ref={searchResultHolder}>
			{/* <div className={style['search-header']}>
				<div className={style['icon-holder']} onClick={goBack}>
					<i className={`${style['back-icon']} icon-HDRback`}></i>
				</div>
				<form 
					className={style['search-form']}
					action="." 
					onSubmit={(e) => {e.preventDefault()}}>
					<input
						ref={inputRef}
						id='searchProduct'
						name='searchProduct'
						type='search'
						className={style['search-input']}
						placeholder={'Search'}
						onChange={e => onValChange(e)}
						value={searchText}
						autoComplete="off"
						onFocus={() => {setInputFocus(true);}}
						onBlur={() => {setInputFocus(false);}}
						autoFocus
				/>
				</form>
				{searchText && !isSearching && (
					<div
						className={style['icon-holder']}
						onClick={() => onValChange()}
					>
						<i
							className={`${style['clear-icon']} icon-closeSearch`}
						></i>
					</div>
				)}
				{isSearching && (
					<span className={style['icon-holder']}>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							width='16px'
							height='16px'
							className={style['upload-loader']}
						>
							<circle
								cx='8px'
								cy='8px'
								r='8px'
								className={style['circle']}
							></circle>
						</svg>
					</span>
				)}
			</div> */}
			<div className={`${style['search-box-holder']} ${isScrolled  && props.session.source !="webstore" ? 'scrolled' : ''}  ${(props.deviceData.isMobile && scrollVal>0)?style['search-input-box-shadow']:""}`}>
				{props.session.source != "webstore"? 
					<>
					<SliderHeader
						className={style['search-page-header']}
						heading={'Search'}
						leftIcons={(props.showLeftIcons || props.deviceData.isMobile) ? leftIconArr : []}
						rightIcons={props.deviceData.isMobile ? [] : rightIconArr}
						variant='white'
						headingClass={style['header-title']}
					/>
					<div className={style['search-input-holder']}>
						<form
							className={style['search-form']}
							action="."
							onSubmit={(e) => { e.preventDefault() }}>
							<input
								ref={inputRef}
								id='searchProduct'
								name='searchProduct'
								type='search'
								aria-label={`Search ${props?.session?.profileObject?.SingleLabelWithSpace}`}
								className={`${style['search-input']}  `}
								placeholder={`Enter ${props?.session?.profileObject?.SingleLabelWithSpace} Name`}
								onChange={e => onValChange(e)}
								value={searchText}
								autoComplete="off"
								onFocus={() => { setInputFocus(true); }}
								onBlur={() => { setInputFocus(false); }}
								autoFocus
							/>
							<i className={`${style['search-icon']} icon-HDRsearch`}></i>
							{searchText && !isSearching && (
								<AnimateOnHover
									className={style['icon-holder']}
									onClick={() => onValChange()}
									variant='circle'
								>
									<i
										className={`${style['clear-icon']} icon-HDRcross`}
									></i>
								</AnimateOnHover>
							)}
							{isSearching && (
								<span className={style['icon-holder']}>
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='14px'
										height='14px'
										className={style['upload-loader']}
									>
										<circle
											cx='7px'
											cy='7px'
											r='7px'
											className={style['circle']}
										></circle>
									</svg>
								</span>
							)}
						</form>
			</div>
			</>: 
			<SliderHeader 
			heading='Search'
			className={`${style['webstore-search-header']} ${isScrolled && props.session.source !='webstore' ? 'scrolled' : ''}`}
			showOnlySearch={true}
			searchBox={true}
			leftIcons={leftIconArr}
			searchVariant= "edit"
			rightIcons={[]}
			autoFocus= {true}
			raised={isScrolled}
			inputProps={{
				leftIconClick: leftIconArr[0].onClick,
				leftIconClass: 'icon-HDRback',
				placeholder: 'Search Product',
				onChange: onValChange,
				isSearchLoading: isSearching,
				onClear: onValChange,
				val: searchText
			}}
			/>
		}
			</div>
			<CSSTransition>
				<div
					onTouchMove={closeKeypad}
					className={`${style['result-holder']} ${
						!result.length ? style['no-result'] : ''
						} ${
							!result.length && inputFocus && props.deviceData.isIphone ? style['no-result-fixed'] : ''
						}`}
				>
					{searchText && result && (
						<ProductList
							{...props}
							products={result}
							pageType='search'
							searchText={searchText}
							confirmDelete={confirmDelete}
							isAuditor={isAuditor}
							fromSelectProductSlider= {props.isPhoto}
							isSpecialContract={isSpecialContract}
						/>
					)}

					{!result.length && searchText && !isSearching && (
						  <NoResultFound/>
					)}
				</div>
			</CSSTransition>
		</div >
			{props.showLibrarySlider && props.deviceData.isMobile && (
				<VideoListing />
			)}
			{props.confirmDeleteModal ? <ConfirmDelete
				productData={productData}
				onDelete={deleteProduct}
				onModalClose={onDeleteModalClose}
				productsLength={props.deletionPendingList.length}
				isMultiSelect={isMultiSelect}
			/> : null}
			{props.deletionPendingList.length ? (
				<AuthWrapper>
					<div className={style['search-delete-btn-holder']}>
						<Button
							className={style['full-width-delete-btn']}
							clickHandler={() => {
								confirmDelete(props.allProducts[props.deletionPendingList[0]], props.deletionPendingList.length > 1)
							}}
						>
							{props.deletionPendingList.length > 1 ? 'Delete Products' : 'Delete Product'}
						</Button>
					</div>
				</AuthWrapper>
			) : null}
		</>
	);
});

const mapStateToProps = (state, props) => {
	return {
		onProductClick: props.onProductClick,
		readOnlyProduct: props.readOnlyProduct,
		onlyForSelection: props.onlyForSelection,
		search: state.products.search,
		session: state.session,
		deviceData: state.deviceData,
		showLibrarySlider: state.videoLibrary.showLibrarySlider,
		deletionPendingList: state.products.deletionPendingList,
		allProducts: state.products.allProducts,
		confirmDeleteModal: state.products.confirmDeleteModal,
		tabKey: state.products.tabKey,
		filterProductObj: state.products.filterProductObj,
		fromEditProductService: state.products.fromEditProductService
	};
};

export default connect(mapStateToProps, {
	getListingData,
	getVendorProducts,
	resetSearchData,
	setCurrentEditPage,
	updateDeletionPending,
	updateProductStatus,
	deleteProduct,
	toggleConfirmDelete,
	showHideLoader,
	setTabStatus,
	toggleEditProductSlider
})(SearchProduct);
